export default "__VITE_ASSET__LJKqUwDI__"